import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'mesc-administration',
  templateUrl: './administration.component.html',
  host: { 'class': 'router-outlet' },
})
export class MescAdministrationComponent implements OnInit {

  isAdminRoute: boolean;
  activeRoute: string;

  constructor(
    public readonly router: Router,
    private readonly location: Location
  ) { }

  ngOnInit() { }

  onBack = () => this.location.back();

  validateRoute = (url: string) => {
    this.activeRoute = url.split('/').pop().replace('-', ' ');
    this.isAdminRoute = this.activeRoute.toLowerCase().includes('admin');
  }

}
